import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
import { useDeliveryState } from '../../../context/CheckoutDeliveryContext';
import CustomerUtil from '../../../util/CustomerUtil';
import { useAemConfig } from '@as-react/common-components';
import { customerQueries } from '@as-react/common-queries';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { DeliveryPreselectedCardView } from './DeliveryPreselectedCardView';
import { useFormContext } from 'react-hook-form';
export const CustomerDetailsPreview = ({ onEdit }) => {
    const { defaultRequestParams, servicesEndpoint, lang } = useAemConfig();
    const { t } = useTranslation([I18N_NAMESPACES.checkout]);
    const [{ info }] = useDeliveryState();
    const { getTitles } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { data: customerTitles } = useQuery(getTitles({ lang }));
    const values = useFormContext().getValues('customer');
    if (!values && !info.customerDetails) {
        return null;
    }
    const customerNames = values || CustomerUtil.getCustomerNames(info);
    const getCustomerTitle = (id) => {
        var _a;
        if (!customerTitles) {
            return '';
        }
        return ((_a = customerTitles.options.find(title => title.value === id)) === null || _a === void 0 ? void 0 : _a.label) || '';
    };
    const getCustomerDetails = () => `${getCustomerTitle(customerNames.idTitle)} ${customerNames.firstName} ${customerNames.middleName} ${customerNames.lastName}`;
    return (_jsx(DeliveryPreselectedCardView, { testId: "customer_details_card", header: _jsxs(_Fragment, { children: [_jsx(TextAlpha, { strong: true, children: t('checkout:checkout.delivery.customer.details.title') }), _jsx(TextAlpha, { children: getCustomerDetails() })] }), onEdit: onEdit }));
};
